import Chart from "../charts/Chart";
import { parseDate } from "../utils/dateParser";
import { getSignedImporto } from "../shared/utils/helpers";

// "Spending over time" — a single gradient-filled trend line of the scheda's
// daily totals, per the design system's "Perspective Graph" spec (section 7
// of the Financial Atelier DESIGN.md): primary-to-transparent gradient area
// instead of a flat/stacked bar chart.
const SpendingLineChart = ({ singleScheda }) => {
  if (!singleScheda?.notaSpese?.length) {
    return null;
  }

  const notes = singleScheda.notaSpese.filter((n) => n?.inserimentoData);
  if (notes.length === 0) {
    return null;
  }

  // Aggregate total spend per day across all collaborators.
  const totalsByDate = new Map();
  notes.forEach((n) => {
    const dateStr = parseDate(n.inserimentoData);
    totalsByDate.set(dateStr, (totalsByDate.get(dateStr) || 0) + getSignedImporto(n));
  });

  const sortedDates = [...totalsByDate.keys()].sort(
    (a, b) => new Date(a.split("/").reverse().join("-")) - new Date(b.split("/").reverse().join("-"))
  );
  const values = sortedDates.map((d) => totalsByDate.get(d));

  const lineChartData = {
    labels: sortedDates,
    datasets: [
      {
        label: "Spending",
        data: values,
        borderColor: "#003461", // --primary
        borderWidth: 2,
        tension: 0.35,
        pointRadius: 3,
        pointHoverRadius: 5,
        pointBackgroundColor: "#003461",
        pointBorderColor: "#ffffff",
        pointBorderWidth: 1.5,
        fill: true,
        backgroundColor: (context) => {
          const { ctx, chartArea } = context.chart;
          if (!chartArea) return "rgba(39, 96, 157, 0.12)";
          const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, "rgba(39, 96, 157, 0.30)"); // --surface-tint, glass-filled near the line
          gradient.addColorStop(1, "rgba(39, 96, 157, 0)"); // transparent at the baseline
          return gradient;
        },
      },
    ],
  };

  const lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (item) => ` € ${item.parsed.y.toFixed(2)}`,
        },
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#727781" },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#e1e3e4" },
        ticks: {
          color: "#727781",
          callback: (value) => `€${value}`,
        },
      },
    },
  };

  return (
    <div className="dashboard-card mb-3">
      <div className="px-3 pt-3 pb-1">
        <p className="scheda-row-amount-label mb-1">
          {sortedDates[0]} - {sortedDates[sortedDates.length - 1]}
        </p>
        <h6 className="mb-0">Spending over time</h6>
      </div>
      <div className="p-3" style={{ height: "220px" }}>
        <Chart type="line" data={lineChartData} options={lineChartOptions} />
      </div>
    </div>
  );
};

export default SpendingLineChart;
